var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showBack,
              expression: "showBack",
            },
          ],
        },
        [
          _vm.showMenu
            ? [
                _c("ul", { staticClass: "nav" }, [
                  _c(
                    "li",
                    {
                      class: {
                        selected:
                          _vm.currentPath == "/sales/salesReps/home"
                            ? true
                            : false,
                      },
                    },
                    [
                      _c(
                        "router-link",
                        {
                          class: [_vm.lang],
                          attrs: { to: "/sales/salesReps/home" },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("home")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "li",
                    {
                      class: {
                        selected:
                          _vm.currentPath == "/sales/salesReps/campaign"
                            ? true
                            : false,
                      },
                    },
                    [
                      _c(
                        "router-link",
                        {
                          class: [_vm.lang],
                          attrs: { to: "/sales/salesReps/campaign" },
                        },
                        [_vm._v(_vm._s(_vm.$t("campaigns")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "li",
                    {
                      class: {
                        selected:
                          _vm.currentPath == "/sales/salesReps/dashboard"
                            ? true
                            : false,
                      },
                    },
                    [
                      _c(
                        "router-link",
                        {
                          class: [_vm.lang],
                          attrs: { to: "/sales/salesReps/dashboard" },
                        },
                        [_vm._v(_vm._s(_vm.$t("dashboard")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "li",
                    {
                      class: {
                        selected:
                          _vm.currentPath == "/sales/salesReps/linkin"
                            ? true
                            : false,
                      },
                    },
                    [
                      _c(
                        "router-link",
                        {
                          class: [_vm.lang],
                          attrs: { to: "/sales/salesReps/linkin" },
                        },
                        [_vm._v(_vm._s(_vm.$t("linkedinAccountSetting")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "li",
                    {
                      class: {
                        selected:
                          _vm.currentPath == "/sales/salesReps/draft"
                            ? true
                            : false,
                      },
                    },
                    [
                      _c(
                        "router-link",
                        {
                          class: [_vm.lang],
                          attrs: { to: "/sales/salesReps/draft" },
                        },
                        [_vm._v(_vm._s(_vm.$t("campaignDraft")))]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            : [
                _c("p", { staticClass: "back" }, [
                  _c(
                    "span",
                    { on: { click: _vm.goback } },
                    [
                      _c("a-icon", { attrs: { type: "left" } }),
                      _c("span", { class: [_vm.lang] }, [
                        _vm._v(_vm._s(_vm.$t("back"))),
                      ]),
                    ],
                    1
                  ),
                ]),
              ],
        ],
        2
      ),
      _c(
        "keep-alive",
        [
          _c(
            "div",
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showBack,
                    expression: "showBack",
                  },
                ],
                staticStyle: { height: "50px" },
              }),
              _c("PostTitle", { attrs: { isSales: true } }),
            ],
            1
          ),
          _vm.$route.meta.KeepAlive
            ? _c("router-view", {
                key: _vm.$route.path,
                attrs: {
                  exclude: [
                    "createCampaign",
                    "/sales/salesReps/createCampaign",
                  ],
                },
              })
            : _vm._e(),
        ],
        1
      ),
      !_vm.$route.meta.KeepAlive ? _c("router-view") : _vm._e(),
      _c("PayModal", { attrs: { camp: "1" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }